export * from './remind-activation-code.component';
